import { getApiBasePath } from '~/services/runtimeCfg'
import { glFetch, glGetAll } from '../common'

/**
 * snippets can be defined in the project settings
 * i.e: https://gitlab.com/kampaay/kampaay-be/-/snippets
 */

export type GLSnippet = {
  id: number
  author: GLUser
  title: string
}

export const getSnippets = async (projectId: number) =>
  glGetAll<GLSnippet[]>(projectId.toString(), 'snippets')

export const getSnippetContent = async (snippetId: number) => {
  const response = await glFetch(
    `${getApiBasePath()}/snippets/${snippetId}/raw`,
  )
  return response.text()
}
